<svelte:head>

    <title>Plans • keyosh</title>

</svelte:head>

<script>
    import Plans from "../../components/onboarding/plans.svelte"
</script>


<section>

    <Plans />

</section>


<style>

    section {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: inherit;
        position: relative;
    }

    @media screen and (max-width: 1024px) {

        section {
            flex-direction: column;
        }

    }

</style>
